package com.dignicate.web.ui.components.footer

import androidx.compose.runtime.Composable
import com.dignicate.web.generated.BuildInfo
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun BuildInfoFooter() {
    // ランタイムで正しい値が入っているか確認するためのログ（ブラウザの console に出ます）
    try {
        console.log("[BuildInfoFooter] BuildInfo at runtime:", BuildInfo.VERSION, BuildInfo.GIT_HASH)
    } catch (_: Throwable) {
        // no-op
    }

    // メタ情報ブロックの内側（親が中央寄せの wrapper を提供する想定）
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            gap(4.px)
            width(100.percent)
        }
    }) {
        // Build 情報は1行にまとめる。nowrap にして改行を防止、line-height を詰めて見た目を整える。
        Span({
            style {
                fontSize(12.5.px)
                lineHeight(1.25.toString())
                opacity(0.72)
                color(Color("var(--muted, #666)"))
                fontFamily("ui-monospace", "SFMono-Regular", "Menlo", "Monaco", "Roboto Mono", "Noto Sans Mono", "monospace")
                whiteSpace("nowrap")
                property("overflow-wrap", "normal")
            }
        }) {
            Text("Build (${BuildInfo.GIT_HASH}) v${BuildInfo.VERSION}")
        }
    }
}
